<div class="w-full">
  <div class="flex flex-column py-2 w-full pr-2">
    <h2 class="m-0 font-medium text-4xl section-title">
      {{ 'itpManagement.sisItpManagement' | translate }}
    </h2>
    <span class="text-sm text-600 help-text">
      {{ 'itpManagement.sisItpManagementDescription' | translate }}
    </span>
  </div>

  <p-divider class="w-full sd-divider-darker divider-margin"></p-divider>

  @if (isLoading()) {
    <div class="flex justify-content-center p-5">
      <p-progressSpinner
        [ariaLabel]="'itpManagement.loadingCredentials' | translate"
      ></p-progressSpinner>
    </div>
  } @else {
    <!-- Credentials Section -->
    <div class="w-full px-2 mb-3">
      <div class="grid grid-nogutter md:grid gap-3">
        <div class="col-12 md:col-4">
          <label
            for="clientId"
            class="m-0"
          >
            {{ 'itpManagement.clientId' | translate }}
          </label>
          <input
            id="clientId"
            class="dap-client-id-input"
            type="text"
            pInputText
            class="w-full"
            [class.ng-invalid]="clientIdTouched() && (!clientId.trim() || !isValidGuid(clientId))"
            [class.ng-dirty]="clientIdTouched()"
            [(ngModel)]="clientId"
            (blur)="onClientIdBlur()"
          />
          @if (clientIdTouched() && !clientId.trim()) {
            <small class="error-label">
              {{ 'itpManagement.clientIdRequired' | translate }}
            </small>
          } @else if (clientIdTouched() && clientId.trim() && !isValidGuid(clientId)) {
            <small class="error-label">
              {{ 'itpManagement.clientIdInvalidGuid' | translate }}
            </small>
          }
        </div>
        <div class="col-12 md:col-4">
          <label
            for="secret"
            class="block m-0"
          >
            {{ 'itpManagement.secret' | translate }}
          </label>
          <input
            id="secret"
            type="password"
            pInputText
            class="dap-secret-input w-full"
            placeholder="••••••••"
            [(ngModel)]="secret"
          />
        </div>
      </div>
    </div>

    <div class="w-full px-2">
      <p-card class="w-full">
        @for (step of integrationSteps(); track step.id; let last = $last) {
          <div>
            <div class="mapping-content">
              <div class="mapping-text">
                <h3
                  class="font-medium text-[20px] m-0"
                  [id]="'step-label-' + step.id"
                >
                  {{ getStepKey(step.step) | translate }}
                </h3>
                <span
                  class="help-text"
                  [id]="'step-desc-' + step.id"
                >
                  {{ getStepKey(step.desc) | translate }}
                </span>
              </div>
              <p-select
                class="dap-source-select w-20rem"
                optionLabel="label"
                optionValue="value"
                [ariaLabelledBy]="'step-label-' + step.id"
                [placeholder]="'itpManagement.selectSource' | translate"
                [options]="sourceOptions()"
                [checkmark]="true"
                [filter]="true"
                [appendTo]="'body'"
                [ngModel]="step.source"
                (ngModelChange)="onSourceChange(step, $event)"
              ></p-select>
            </div>
          </div>
          @if (!last) {
            <p-divider class="w-full sd-divider-darker divider-margin"></p-divider>
          }
        }
      </p-card>
    </div>

    <div class="w-full px-2 mt-3 flex justify-content-end">
      <p-button
        class="dap-save-btn"
        [label]="'save' | translate"
        [loading]="isSaving()"
        [disabled]="isSaving()"
        (click)="saveAll()"
      ></p-button>
    </div>
  }
</div>
